{
  "new": "Новая заметка",
  "searchPlaceholder": "Поиск заметок",
  "searchClear": "Очистить поиск",
  "searchTooShort": "Введите хотя бы два символа",
  "empty": "Заметок пока нет",
  "nothingFound": "Ничего не найдено",
  "loadFailed": "Не удалось загрузить заметки",
  "loading": "Загружаем заметки",
  "loadingMore": "Загружаем ещё заметки",
  "shared": "В общем доступе",
  "open": "Открыть заметку",
  "title": "Название",
  "titlePlaceholder": "Название заметки",
  "descriptionPlaceholder": "Добавьте описание…",
  "save": "Сохранить",
  "cancel": "Отмена",
  "delete": "Удалить",
  "deleteConfirm": "Удалить заметку? Файлы заметки тоже будут удалены.",
  "filesDrop": "Перетащите файлы сюда",
  "shares": "Доступ",
  "shareProject": "Проект",
  "shareCompany": "Компания",
  "sharePerson": "Пользователь",
  "shareRead": "Читатель",
  "shareEdit": "Редактор",
  "shareAdd": "Добавить",
  "shareSearch": "Компания, проект или человек",
  "shareGroupCompany": "Компания",
  "shareGroupProjects": "Проекты",
  "shareGroupPeople": "Люди",
  "shareColumnWho": "Кому",
  "shareColumnAccess": "Доступ",
  "shareRemove": "Закрыть доступ",
  "shareInactive": "Больше не в компании",
  "shareCompanyWith": "Всей компании «{{name}}»",
  "task": "Создать задачу",
  "cut": "Вырезать в задачу",
  "taskTitle": "Задача из заметки",
  "taskProject": "Проект",
  "taskName": "Название",
  "taskCreate": "Создать",
  "taskNeedProject": "Выберите проект",
  "taskNeedTitle": "Введите название",
  "taskNeedSelection": "Выделите фрагмент, который нужно вырезать",
  "readOnly": "Только чтение",
  "pin": "Закрепить",
  "unpin": "Открепить",
  "actions": "Действия",
  "copyLink": "Скопировать ссылку",
  "linkCopied": "Ссылка скопирована",
  "copyFailed": "Не удалось скопировать ссылку",
  "backToList": "Назад к списку",
  "openAccess": "Открыть доступ"
}
